

 const kefu=()=>{

//   setTimeout(()=>{
// let scriptId = "script_floatbutton_" + 3;
//         let script = document.getElementById(scriptId);
//         if (script) {
//           document.body.removeChild(script);
//         }
//         script = document.createElement("script");
//         script.id = scriptId;
//         document.body.append(script);
//         script.innerHTML = `(function(a, b, c, d, e, j, s) {\na[d] = a[d] || function() {\n(a[d].a = a[d].a || []).push(arguments)\n};\nj = b.createElement(c),\ns = b.getElementsByTagName(c)[0];\nj.async = true;\nj.charset = 'UTF-8';\nj.src = 'https://static.meiqia.com/widget/loader.js';\ns.parentNode.insertBefore(j, s);\n})(window, document, 'script', '_MEIQIA');\n_MEIQIA('entId', 'ed70e1d176a41fb5929ada2b6c760b78');\n_MEIQIA("showPanel");`;

//   },500)

(function(m, ei, q, i, a, j, s) {
        m[i] = m[i] || function() {
            (m[i].a = m[i].a || []).push(arguments)
        };
        j = ei.createElement(q),
            s = ei.getElementsByTagName(q)[0];
        j.async = true;
        j.charset = 'UTF-8';
        j.src = 'https://visitor-static.meiqia.com/fe-widget-visitor/loader.js';
        s.parentNode.insertBefore(j, s);
    })(window, document, 'script', '_MEIQIA');
    _MEIQIA('entId', '0326e704d61ea2ba721c6ab65686097d');
    // 初始化成功时的回调
    _MEIQIA('allSet');

}

export default kefu


